module.exports = __webpack_public_path__ + "img/img25.c04a896a.svg";